/*
* @Author: 王春岩 <Bolt>
* @Date:   2017-04-19 08:43:52
* @Last Modified by:   lokialone
* @Last Modified time: 2017-06-22 14:18:10
*/

'use strict';

import axios, { CancelToken } from 'axios';
import {
    getDataWrapperFromRes,
    getDataAndErrorFromDataWrapper
} from 'src/api/_error.js';

let cancelSource = CancelToken.source();

/**
 * mock 数据接口
 */

// const instanceMock = axios.create();

// instanceMock.defaults.baseURL = '//mock.souche-inc.com/mock/58ef3d1e18a42b3b484534d6/venus';
// instanceMock.defaults.baseURL = '//mock.souche-inc.com/mock/58f42867c29e6e637ddf1868/1492396135990';
// instanceMock.defaults.baseURL = '//mock.souche-inc.com/mock/15757129510/1492396135990_1493025359036';
// instanceMock.interceptors.response.use((res) => {
//     console.log('正在使用 Mock', res);
//     return res;
// });
// instanceMock.interceptors.response.use(getDataWrapperFromRes);
// instanceMock.interceptors.response.use(getDataAndErrorFromDataWrapper);

/**
 * 数据接口
 */

const instance = axios.create();

// instance.defaults.baseURL = '';
instance.interceptors.request.use((config) => {
    config.cancelToken = cancelSource.token;
    return config;
});
instance.interceptors.response.use(getDataWrapperFromRes);
instance.interceptors.response.use(getDataAndErrorFromDataWrapper);

/**
 * jsonp 数据接口
 */
// 暂无

export default instance;

export const doCancelSource = () => {
    cancelSource.cancel();
    cancelSource = CancelToken.source();
};

/**
 * 输出所有 instatnce, 用于各模块自行选择
 */
export {
    instance as instanceMock,
    instance as instanceDefault
};



// WEBPACK FOOTER //
// ./src/api/_instance.js